import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=5c450e96&"
import script from "./RuleForm.vue?vue&type=script&lang=ts&"
export * from "./RuleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports